import React from "react";
import Biocard from "../../Components/card/bio-card";

const bio = () => {
  return (
    <div>
      <Biocard />
    </div>
  );
};

export default bio;
